import React from 'react';
import { Typography, Grid, Box } from '@material-ui/core';
import StyledBox from 'views/motorcycle_rental/components/ERHoldingSection/ERHoldingSection.styles';
import { withTranslation } from 'config/i18n';
import ImgBox from 'common/components/ImgBox';

const ERHoldingSection = (props) => {
  const { t } = props;
  const erImage = {
    src: '/imgs/er-logo-geo.svg',
    alt: 'eagle-rider-logo',
  };
  const esImage = {
    src: '/imgs/es-logo-geo.svg',
    alt: 'eagle-share-logo',
  };

  return (
    <StyledBox>
      <Grid container alignItems="center">
        <Grid item xs={6}>
          <Box className="ERHSERLogo">
            <ImgBox
              image={erImage}
              imgWidth="168px"
              imgHeight="36px"
              imgObjectFit="contain"
            />
            {/* <Typography className="ERHSText" variant="h5" component="span">
              {t('fe_es_geo_page:eagle_rider')}
            </Typography> */}
          </Box>
        </Grid>
        <Grid item lg={6}>
          <Box className="ERHSESLogo">
            <ImgBox
              image={esImage}
              imgWidth="230px"
              imgHeight="24px"
              imgObjectFit="contain"
            />
            {/* <Typography className="ERHSText" variant="h5" component="span">
              {t('fe_es_geo_page:eagle_share')}
            </Typography> */}
          </Box>
        </Grid>
      </Grid>
      <Typography
        className="ERHSDesc"
        textAlign="center"
        variant="body1"
        component="p"
      >
        {t('fe_es_geo_page:er_holding_description')}
      </Typography>
    </StyledBox>
  );
};

export default withTranslation('fe_es_geo_page')(ERHoldingSection);
